import FeathersDataTable from "./components/FeathersDataTable";
import FeathersCRUD from "./components/FeathersCRUD";

export default { FeathersDataTable, FeathersCRUD };